//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconPersonCircleFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C9.4 20 7.1 18.75 5.64 16.83L6.3 15H17.7L18.36 16.83C16.9 18.75 14.6 20 12 20ZM11.99 6.04C14.05 6.04 15.73 7.72 15.73 9.78C15.73 11.84 14.05 13.52 11.99 13.52C9.93 13.52 8.25 11.84 8.25 9.78C8.25 7.72 9.93 6.04 11.99 6.04Z" fill="currentColor" /></svg>;
}
export default IconPersonCircleFill;